// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","BlogPostMenu__item--admin":"ht_a","BlogPostMenu__item--moderator":"ht_b"};